(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bundle-selector')) {
    class BundleSelector extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', this.#onChange);
        this.#sync(0);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.#onChange);
      }

      #onChange = (event) => {
        const radio = event.target;
        if (!(radio instanceof HTMLInputElement) || radio.type !== 'radio') return;
        this.#setQuantity(radio.value);
      };

      #quantityInput() {
        const scope = this.closest('.shopify-section') || document;
        return scope.querySelector(
          'product-form-component input[name="quantity"], product-form-component input[ref="quantityInput"]'
        );
      }

      #setQuantity(value) {
        const input = this.#quantityInput();
        if (!input || input.value === String(value)) return;
        input.value = value;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      #sync(attempt) {
        const input = this.#quantityInput();
        if (!input) {
          if (attempt < 30) requestAnimationFrame(() => this.#sync(attempt + 1));
          return;
        }
        const checked = this.querySelector('input[type="radio"]:checked');
        if (checked) this.#setQuantity(checked.value);
      }
    }

    customElements.define('bundle-selector', BundleSelector);
  }
  } catch(e) { console.error(e); }
})();

})();
